import React, { useEffect, useState } from "react";
import Subheader from "../todoList/subheader";
import PrescriptionCard from "./prescriptionCard";
import { getService } from "../../services/genericPostService";
import { useNavigate } from "react-router-dom";
import { Path } from "../../RoutesUtils";
import Header from "../header/header";

const Prescription = () => {
  const [prescription, setPrescription] = useState([]);
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate(Path.login);
    } else {
      getPrescription();
    }
  }, []);

  const getPrescription = () => {
    const data = {
      user_id: userId,
    };

    const url = "/fmeApi/get_medicine_prescription.php";
    getService(url, data, setData);
  };

  const setData = (response) => {
    setPrescription(response.prescriptions);
  };

  return (
    <>
      <Header />
      <Subheader title="Recept" href="/prescription/addtask" />
      <div className="w-full container mx-auto mt-9 lg:px-8 px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 lg:gap-10 gap-5">
          {prescription && prescription.length > 0 ? (
            prescription.map((pres, index) => (
              <PrescriptionCard
                key={index}
                {...pres}
                getPrescription={getPrescription}
              />
            ))
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default Prescription;
